import type { GetVideosUsageParams, GetVideosUsageResult } from 'src/types';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { videos } from 'admin/resources';
import { useAdminSelector } from 'admin/reducers';
import { selectActiveOrganizationId } from 'admin/reducers/user/selectors';
import { videoKeys } from '../queryKeys';

const getVideoUsage = async ({ organizationId, ...queryParams }: GetVideosUsageParams) => {
	const query = {
		from: queryParams.from ?? dayjs().startOf('month').format('YYYY-MM-DD'),
		to: queryParams.to ?? dayjs().endOf('month').format('YYYY-MM-DD'),
	};

	const response: ApiV2Response<GetVideosUsageResult> = await videos.getUsage.params({ organizationId }).send(query);

	return response.body;
};

export const useVideosUsage = (params: Partial<Omit<GetVideosUsageParams, 'organizationId'>>) => {
	const organizationId = useAdminSelector(selectActiveOrganizationId);
	return useQuery({
		queryKey: videoKeys.list.usage(organizationId),
		queryFn: () => getVideoUsage({ organizationId, ...params }),
	});
};
